<mat-toolbar class="app-toolbar">
  <app-loading-bar></app-loading-bar>
  <div class="app-toolbar-tools cf-flex-1 cf-flex-row cf-justify-content-start cf-align-items-center">
    <div class="app-logo">
      <a routerLink="/"><img src="assets/images/Flexit_select_stdlogo.svg" alt="FLEXIT Select" /></a>
    </div>
    <div class="arrow-container">
      <div class="arrow dark absolute"></div>
      <div class="arrow light absolute"></div>
    </div>

    <app-breadcrumb class="app-breadcrumbs cf-flex-row"></app-breadcrumb>

    <span class="cf-flex-auto"></span>

    <p class="version">{{ 'UI.Version' | translate }} {{ version }}</p>

    @if (isLoggedIn$ | async) {
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="icon-button with a user menu">
        <mat-icon class="light-dark">account_circle</mat-icon>
      </button>
    }
    <mat-menu #menu="matMenu" xPosition="before">
      @if (hasAdminAccess$ | async) {
        <a mat-menu-item href="Admin/" target="_blank">
          <span [translate]="'UI.Admin'"></span>
        </a>
      }

      @if (hasAdminAndUserAdminAccess$ | async) {
        <a mat-menu-item (click)="exportUsageStatistics()">
          <span [translate]="'UI.ExportUsageStatistics'"></span>
        </a>
      }

      @if (hasHexCalculationAccess$ | async) {
        <a mat-menu-item routerLink="/hex"><span [translate]="'UI.HexCalculation.Link'"></span></a>
      }

      <button mat-menu-item (click)="openUserProfile()">
        <span [translate]="'UI.Profile'"></span>
      </button>
      <button mat-menu-item (click)="openUserSettings()">
        <span [translate]="'UI.Settings'"></span>
      </button>
      <button mat-menu-item routerLink="/logout">
        <span [translate]="'UI.Logout'"></span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
<div class="header-line"></div>
